export const navCartButtonComponent = {
  key: 'navCartButtonComponent',
  name: 'Nav Cart Button Dept-Component',
  siteIdentifier: 'global',

  shoppingCartAriaLabel: 'Shopping Cart',
};
